import { selectPageModelData } from '../store/pageModel/selectors';
import { createSelector } from '@reduxjs/toolkit';

export const selectExperiments = createSelector(
	selectPageModelData,
	model => model?.experiments ?? []
);

export const selectAnalizPDFLink = createSelector(
	selectExperiments,
	experiments =>
		experiments.find(({ internalId }) => internalId === 'ANALIZ_VODY_FILE_LINK')?.externalId
);
